<template>
    <div class="mx-auto">
        <div class="loader" v-if="loading"></div>
        <div v-else>
            <page-title :title="$t('institution.title')" :showTitle="false"></page-title>

            <div class="btn-group" role="group" aria-label="Basic example">
                <button type="button"
                        class="btn btn-primary"
                        @click="backToRegister">
                    <i class="fas fa-th-list"></i> {{ $t('backToList') }}
                </button>
            </div>

            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('institution.information') }}</div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="form-group col-4">
                            <label :for="'number' + _uid" class="font-weight-bold">{{ $t('institution.id') }}</label>
                            <input type="number"
                                   class="form-control"
                                   v-model="institution.id"
                                   readonly />
                        </div>
                        <div class="form-group col-4">
                            <label :for="'type' + _uid" class="font-weight-bold">{{ $t('institution.type') }}</label>
                            <input type="text"
                                   class="form-control"
                                   v-model="institution.type"
                                   readonly />
                        </div>
                        <div class="form-group col-4">
                            <label :for="'level' + _uid" class="font-weight-bold">{{ $t('institution.level') }}</label>
                            <input type="text"
                                   class="form-control"
                                   v-model="institution.level"
                                   readonly />
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="form-group col-4">
                            <label :for="'formalMagistratesCount' + _uid" class="font-weight-bold">{{ $t('institution.stateGazette') }}</label>
                            <input type="text"
                                   class="form-control"
                                   v-model="institution.stateGazette"
                                   readonly />
                        </div>
                        <div class="form-group col-8">
                            <label :for="'name' + _uid" class="font-weight-bold">{{ $t('institution.name') }}</label>
                            <input type="text"
                                   class="form-control"
                                   v-model="institution.name"
                                   readonly />
                            <span class="text-danger" v-if="errors.has('name' + _uid)">{{ errors.first('name' + _uid) }}</span>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="form-group col-4">
                            <label :for="'protocol' + _uid" class="font-weight-bold">{{ $t('institution.protocol') }}</label>
                            <input type="text"
                                   class="form-control"
                                   v-model="institution.protocol"
                                   readonly />
                        </div>
                        <div class="form-group col-4">
                            <label :for="'realMagistratesCount' + _uid" class="font-weight-bold">{{ $t('institution.realMagistratesCount') }}</label>
                            <input type="text"
                                   class="form-control"
                                   v-model="institution.realMagistratesCount"
                                   readonly />
                        </div>
                        <div class="form-group col-4">
                            <label :for="'realEmployeesCount' + _uid" class="font-weight-bold">{{ $t('institution.realEmployeesCount') }}</label>
                            <input type="text"
                                   class="form-control"
                                   v-model="institution.realEmployeesCount"
                                   readonly />
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="form-group col-4">
                            <label :for="'formalMagistratesCount' + _uid" class="font-weight-bold">{{ $t('institution.formalMagistratesCount') }}</label>
                            <input type="text"
                                   class="form-control"
                                   v-model="institution.formalMagistratesCount"
                                   readonly />
                        </div>
                        <div class="form-group col-4">
                            <label :for="'formalEmployeesCount' + _uid" class="font-weight-bold">{{ $t('institution.formalEmployeesCount') }}</label>
                            <input type="text"
                                   class="form-control"
                                   v-model="institution.formalEmployeesCount"
                                   readonly />
                        </div>
                        <div class="form-group col-4">
                            <label :for="'totalFormalCount' + _uid" class="font-weight-bold">{{ $t('institution.totalFormalCount') }}</label>
                            <input type="text"
                                   class="form-control"
                                   v-model="institution.totalFormalCount"
                                   readonly />
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="form-group col-12">
                            <label class="font-weight-bold" :for="'areaOfApeal' + _uid">{{ $t('address.areaOfAppeal') }}</label>
                            <input type="text"
                                   class="form-control "
                                   readonly
                                   v-model="areaOfApeal"
                                   :name="'areaOfApeal' + _uid"
                                   :data-vv-as="$t('address.streetNum')"
                                   :id="'areaOfApeal' + _uid" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('institution.mainInfo') }}</div>
                </div>
                <div class="card-body">
                    <company :company="institution.company"></company>
                </div>
            </div>

            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('otherFields.otherFields') }}</div>
                </div>
                <div class="card-body">
                    <otherFields :otherFields="institution.otherFields"></otherFields>
                </div>
            </div>

            <div class="mt-3" v-if="institution">
                <AuxiliaryRegisterDetails :entryId="institution.auxRegisterEntityId"></AuxiliaryRegisterDetails>
            </div>
        </div>
    </div>
</template>

<script>
    import OtherFields from '../../../components/otherFields/OtherFieldsDetails.vue';
    import Company from '../../../components/company/CompanyDetails.vue'
    import { InstitutionDetails } from '../../../models/models';
    import PageTitle from '../../../components/common/PageTitle';
    import AuxiliaryRegisterDetails from '../../../components/dynamic/AuxiliaryRegisterDetails'

    export default {
        components: {
            PageTitle,
            OtherFields,
            Company,
            AuxiliaryRegisterDetails
        },
        props: {
            id: {
                type: Number,
                required: true
            },
            returnUrl: {
                type: String,
                default() {
                    return '';
                }
            }
        },
        data() {
            return {
                institution: new InstitutionDetails(),
                loading: false,
            }
        },
        methods: {
            backToRegister() {
                this.$router.push(this.returnUrl || '/registers/institutions');
            },
            loadData() {
                this.loading = true;
                this.$http.get(`/api/institution/GetDetails/${this.id}`).then(result => {
                    this.institution = new InstitutionDetails(result.data);
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('buttons.load.btnText'),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                }).then(() => { this.loading = false; });
            }
        },
        mounted() {
            this.loadData();
        },
        computed: {
            totalFormalCount() {
                const count = this.institution.formalEmployeesCount + this.institution.formalMagistratesCount;
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.institution.totalFormalCount = count;
                return count;
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === 'en';
            },
            areaOfApeal() {
                if (!this.institution.company.registeredAddress.areaOfAppeal) {
                    return '';
                }

                return `${this.isEnVersion ? this.institution.company.registeredAddress.areaOfAppeal.nameEn : this.institution.company.registeredAddress.areaOfAppeal.name} \\ ${this.institution.company.registeredAddress.areaOfAppeal.districtCode}`
            }
        }
    }
</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>
